<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      :visible="visible"
      direction="rtl"
      :size="1200"
      show-close
      @close="close"
      :before-close="handleClose"
      append-to-body
    >
      <div>
        <FabricColorTable :tableHeight="500" @chooseFabric="chooseFabric" />
        <div class="choose-fabric__wrapper" v-if="visible">
          <div>
            {{ $l('INDEX.evg_sku_label_selected_fabric') || '已选择面料' }}
          </div>
          <div v-for="(item, index) in fabricList" :key="item.id">
            <FabricAddInfo
              :currIndex="index"
              :fabricInfo="item"
              :disabled="disabled"
              :proofingCode="proofingCode"
              :showSaveButton="false"
              @delFabric="delFabric"
              @updateFabric="updateFabric"
              ref="fabricInfo"
            ></FabricAddInfo>
          </div>
        </div>
        <div class="d-flex justify-content-end mb-2 mt-3">
          <el-button
            type="primary"
            size="small"
            v-if="!disabled && !isEmpty"
            @click="save()"
            >{{ $l('INDEX.btn_save') || '保存' }}</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import FabricColorTable from './table.vue'
import FabricAddInfo from '../fabric-add-info'
import EditLoading from '@/mixins/edit-loading'

export default {
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    proofingCode: { type: String, default: '' },
    title: { type: String, default: '' },
  },
  mixins: [EditLoading],
  components: { FabricColorTable, FabricAddInfo },
  data() {
    return {
      fabricList: [],
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    isEmpty() {
      return !this.fabricList.length
    },
  },
  methods: {
    getData() {
      this.fabricList = []
      if (this.proofingCode) {
        this.$api
          .customerProofingFabricListApi({
            proofingCode: this.proofingCode,
          })
          .then((res) => {
            this.fabricList = res.body.data
          })
      }
    },
    close() {
      if (!this.disabled) this.$emit('reload')
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    updateFabric(index, fabric) {
      this.fabricList.splice(index, 1, { ...fabric })
    },
    chooseFabric(fabric) {
      const { fabricColorNo } = fabric
      const index = this.fabricList.findIndex((e) => {
        return e.fabricColorNo == fabricColorNo
      })
      if (index < 0) {
        this.fabricList.splice(0, 0, { ...fabric, id: new Date().getTime() })
      }
    },
    async save() {
      const fiRefs = this.$refs.fabricInfo || []
      const fabricData = []
      for (let i = 0; i < fiRefs.length; i++) {
        if (fiRefs[i]) {
          const fd = fiRefs[i].getFabricData()
          const res = await fiRefs[i].validateForm()
          if (!res) {
            return
          }
          fabricData.push(fd)
        }
      }
      if (fabricData && fabricData.length) {
        this.$emit('saveBatch', fabricData)
      }
    },

    delFabric(index) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.fabricList.splice(index, 1)
      })
    },
    handleClose(done) {
      if (this.disabled) {
        this.close()
        return
      }
      this.$confirm(
        this.$l('INDEX.tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  padding: 0 20px 12px;
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #141516;
  display: flex;
  margin-bottom: 12px;
  padding: 10px 20px 0;
}
</style>
